const n = `:deep(.n-input--focus){--n-border: none !important;--n-border-focus: none !important;--n-box-shadow-focus: none !important;--n-box-shadow: none !important;border:none!important}:deep(.n-form-item){margin-bottom:20px}:deep(.n-form-item-label){font-weight:500;color:#333}:deep(.n-input__textarea-el){min-height:100px}:deep(.n-upload-trigger){display:inline-block}
`;
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-modify-dialog/aiModifyDialog.ce.vue3.js
// module id = 1155
// module chunks = 41